import { useEffect, useState, useCallback } from "react";

export type GalleryPhoto = {
  id: string;
  src: string;
  alt: string;
  location: "remagen" | "bonn";
  caption?: string;
};

const remagenPhotos: GalleryPhoto[] = [
  {
    id: "remagen-01",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/2d12e831-0844-4882-9565-d004dfa5dff6_compressed_Remagen01.webp",
    alt: "Eingangsbereich des Vocatur-Büros in Remagen",
    location: "remagen",
    caption: "Römerstr. 1, 53424 Remagen.",
  },
  {
    id: "remagen-05",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/c5cae847-d74c-41cb-ac9d-5fad797ce3f0_compressed_Remagen05.webp",
    alt: "Detailansicht Klingel im Vocatur-Büro Remagen",
    location: "remagen",
    caption: "Klingeling.",
  },
  {
    id: "remagen-06",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/a91f8592-d979-4342-9810-eaa1f36bc8bb_compressed_Remagen06.webp",
    alt: "Außenansicht des Vocatur-Büros in Remagen",
    location: "remagen",
    caption: "Herzlich willkommen.",
  },
  {
    id: "remagen-02",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/7c7591e0-a6c7-481c-be98-123bf4766cf0_compressed_Remagen02.webp",
    alt: "Büroraum mit Hirschkopf-Deko im Vocatur-Büro Remagen",
    location: "remagen",
    caption: "Das Reh ist nicht die Frau vom Hirsch.",
  },
  {
    id: "remagen-04",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/a2199b73-c73c-4c43-bd02-60431738fdb0_compressed_Remagen04.webp",
    alt: "Gemeinschaftsbereich im Vocatur-Büro Remagen",
    location: "remagen",
    caption: "Wir freuen uns auf Sie.",
  },
  {
    id: "remagen-03",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/10727207-fed7-4b90-ba4f-1896f4fbc3e8_compressed_Remagen03.webp",
    alt: "Historisches Bleiglasfenster im Vocatur-Büro Remagen",
    location: "remagen",
    caption: "Unser Leitbild.",
  },
];

const bonnPhotos: GalleryPhoto[] = [
  {
    id: "bonn-04",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/708554a6-02de-469d-b022-22320bb86223_compressed_Bonn04.webp",
    alt: "Lounge mit Fensterfront im Vocatur-Büro Bonn",
    location: "bonn",
    caption: "Quellenstr. 12, 53177 Bonn.",
  },
  {
    id: "bonn-01",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/4016f653-baf8-4f4a-a759-c5c445f7ecde_compressed_Bonn01.webp",
    alt: "Lounge-Bereich im Vocatur-Büro Bonn",
    location: "bonn",
    caption: "Frisches Obst. Frische Ideen.",
  },
  {
    id: "bonn-02",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/e7b2bb1c-fba1-47f8-bfb3-67c1513396c2_compressed_Bonn02.webp",
    alt: "Detailansicht Kronleuchter und Lounge im Vocatur-Büro Bonn",
    location: "bonn",
    caption: "Nehmen Sie Platz.",
  },
  {
    id: "bonn-03",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/91973c9a-6da7-4fe5-95b0-f662be53cd00_compressed_Bonn03.webp",
    alt: "Besprechungsraum im Vocatur-Büro Bonn",
    location: "bonn",
    caption: "Wir kommen gleich.",
  },
  {
    id: "bonn-05",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/3ddbf03b-c925-44df-89dd-84fa54dd433b_compressed_Bonn05.webp",
    alt: "Außenansicht des Vocatur-Büros in Bonn",
    location: "bonn",
    caption: "Hier gehen nicht nur die Kronleuchter an.",
  },
  {
    id: "bonn-06",
    src: "https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/96c0b36b-a60a-4b4f-b110-9cce6b38e894_compressed_Bonn06.webp",
    alt: "Abendansicht des Lounge-Bereichs im Vocatur-Büro Bonn",
    location: "bonn",
    caption: "Auf bald.",
  },
];

const allPhotos: GalleryPhoto[] = [...remagenPhotos, ...bonnPhotos];

export default function GalleryModal({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [lightboxId, setLightboxId] = useState<string | null>(null);

  const lightboxPhoto = allPhotos.find((p) => p.id === lightboxId) ?? null;
  const lightboxIndex = lightboxPhoto
    ? allPhotos.findIndex((p) => p.id === lightboxPhoto.id)
    : -1;

  const close = useCallback(() => {
    setLightboxId(null);
    onClose();
  }, [onClose]);

  const next = useCallback(() => {
    if (lightboxIndex < 0 || allPhotos.length === 0) return;
    const n = (lightboxIndex + 1) % allPhotos.length;
    setLightboxId(allPhotos[n].id);
  }, [lightboxIndex]);

  const prev = useCallback(() => {
    if (lightboxIndex < 0 || allPhotos.length === 0) return;
    const p = (lightboxIndex - 1 + allPhotos.length) % allPhotos.length;
    setLightboxId(allPhotos[p].id);
  }, [lightboxIndex]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        if (lightboxId) setLightboxId(null);
        else close();
      }
      if (e.key === "ArrowRight" && lightboxId) next();
      if (e.key === "ArrowLeft" && lightboxId) prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, lightboxId, next, prev, close]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-stretch justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Galerie der Standorte"
    >
      {/* backdrop */}
      <div
        className="absolute inset-0 bg-bg/90 backdrop-blur-md"
        onClick={close}
      />

      {/* sheet */}
      <div className="relative w-full h-full overflow-y-auto">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-20">
          {/* header */}
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div>
              <span className="text-xs tracking-[0.4em] uppercase text-moss mb-3 block">
                · UNSERE STANDORTE
              </span>
              <h2 className="font-display text-4xl md:text-6xl font-light leading-tight text-ink">
                Echte Einblicke
              </h2>
            </div>

            <button
              onClick={close}
              className="self-start md:self-end w-11 h-11 flex items-center justify-center rounded-full border border-ink/20 hover:bg-ink hover:text-bg text-ink transition-all cursor-pointer"
              aria-label="Galerie schließen"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>

          {/* Quote */}
          <div className="mb-16 md:mb-20 max-w-4xl">
            <p className="font-display italic text-xl md:text-2xl text-ink leading-relaxed">
              Keine Filmkulisse. Keine Stockfotos. Sondern die Räume, in denen
              täglich gearbeitet, telefoniert und organisiert wird.
            </p>
          </div>

          {/* Remagen Section */}
          <section className="mb-16 md:mb-24">
            <div className="mb-8 md:mb-10">
              <span className="text-xs tracking-[0.3em] uppercase text-moss mb-3 block">
                · Hauptsitz
              </span>
              <h3 className="font-display text-3xl md:text-5xl font-light text-ink mb-4">
                Remagen
              </h3>
              <p className="text-inkDim text-sm md:text-base max-w-xl leading-relaxed">
                Das Herz von Vocatur. Hier laufen viele der Gespräche zusammen,
                mit denen unsere Kunden neue Kunden gewinnen, bestehende Kunden
                betreuen und erreichbar bleiben.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {remagenPhotos.map((photo) => (
                <button
                  key={photo.id}
                  onClick={() => setLightboxId(photo.id)}
                  className="group text-left rounded-xl overflow-hidden border border-line bg-bgSoft/60 hover:border-moss/40 transition-all cursor-pointer"
                >
                  <div className="relative w-full aspect-[4/3] overflow-hidden bg-bg">
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      title={photo.caption}
                      className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
                      loading="lazy"
                    />
                  </div>
                  {photo.caption && (
                    <div className="p-4">
                      <p className="text-xs text-inkDim tracking-wide">
                        {photo.caption}
                      </p>
                    </div>
                  )}
                </button>
              ))}
            </div>
          </section>

          {/* Bonn Section */}
          <section className="mb-16 md:mb-24">
            <div className="mb-8 md:mb-10">
              <span className="text-xs tracking-[0.3em] uppercase text-moss mb-3 block">
                · Zweigstelle
              </span>
              <h3 className="font-display text-3xl md:text-5xl font-light text-ink mb-4">
                Bonn
              </h3>
              <p className="text-inkDim text-sm md:text-base max-w-xl leading-relaxed">
                Unser zweiter Standort - unser „Oval Office“. Nur wenige
                Kilometer entfernt. Aber nah genug, um gemeinsam für unsere
                Kunden da zu sein.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {bonnPhotos.map((photo) => (
                <button
                  key={photo.id}
                  onClick={() => setLightboxId(photo.id)}
                  className="group text-left rounded-xl overflow-hidden border border-line bg-bgSoft/60 hover:border-moss/40 transition-all cursor-pointer"
                >
                  <div className="relative w-full aspect-[4/3] overflow-hidden bg-bg">
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      title={photo.caption}
                      className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-[1.04]"
                      loading="lazy"
                    />
                  </div>
                  {photo.caption && (
                    <div className="p-4">
                      <p className="text-xs text-inkDim tracking-wide">
                        {photo.caption}
                      </p>
                    </div>
                  )}
                </button>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* Lightbox layer */}
      {lightboxPhoto && (
        <div
          className="absolute inset-0 z-[90] bg-bg/95 backdrop-blur-md flex items-center justify-center px-4 md:px-12 py-10"
          onClick={() => setLightboxId(null)}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              setLightboxId(null);
            }}
            className="absolute top-6 right-6 w-11 h-11 flex items-center justify-center rounded-full border border-ink/20 hover:bg-ink hover:text-bg text-ink transition-all cursor-pointer z-10"
            aria-label="Bild schließen"
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          {allPhotos.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  prev();
                }}
                className="absolute left-3 md:left-8 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-ink/20 hover:bg-ink hover:text-bg text-ink transition-all cursor-pointer z-10"
                aria-label="Vorheriges Bild"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  next();
                }}
                className="absolute right-3 md:right-8 top-1/2 -translate-y-1/2 w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-ink/20 hover:bg-ink hover:text-bg text-ink transition-all cursor-pointer z-10"
                aria-label="Nächstes Bild"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </>
          )}

          <div
            className="relative w-full max-w-5xl flex flex-col gap-5"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative w-full rounded-2xl overflow-hidden bg-bgSoft border border-line flex items-center justify-center max-h-[70vh]">
              <img
                src={lightboxPhoto.src}
                alt={lightboxPhoto.alt}
                title={lightboxPhoto.caption}
                className="max-w-full max-h-[70vh] object-contain"
              />
            </div>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-moss mb-2">
                  {lightboxPhoto.location === "remagen" ? "Remagen" : "Bonn"}
                </div>
                <h3 className="font-display text-xl md:text-2xl text-ink leading-snug">
                  {lightboxPhoto.caption || lightboxPhoto.alt}
                </h3>
              </div>
              {allPhotos.length > 1 && (
                <div className="flex items-center gap-5 text-xs text-inkDim shrink-0">
                  <span className="tabular-nums">
                    {lightboxIndex + 1} / {allPhotos.length}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}